import {
  emailRules,
  isLandlinePhoneNumberValid,
  isMobilePhoneNumberValid
} from '../../../_common/client/helpers/validations';
import useFormFieldsCrossValidation from './useFormFieldsCrossValidation.mjs';

const useMailMobileLandlineCrossValidation = (form, getMiddleBoolean) => {
  const fieldsMetadata = {
    email: {
      formKey: 'customer.emails.0',
      validatorFunction: emailRules,
      getValue: (email) => email?.value,
      baseMiddleBooleanKey: 'ADHERENT_EMAIL_EST_OBLIGATOIRE',
      crossValidationMiddleBooleanKeys: [
        'ADHERENT_TEL_MOBILE_FIXE_EMAIL_EST_OBLIGATOIRE',
        'ADHERENT_TEL_FIXE_EMAIL_EST_OBLIGATOIRE',
        'ADHERENT_TEL_MOBILE_EMAIL_EST_OBLIGATOIRE'
      ]
    },
    mobile: {
      formKey: 'customer.phones.0',
      validatorFunction: isMobilePhoneNumberValid,
      getValue: (phone) => phone?.number,
      baseMiddleBooleanKey: 'ADHERENT_TEL_MOBILE_EST_OBLIGATOIRE',
      crossValidationMiddleBooleanKeys: [
        'ADHERENT_TEL_MOBILE_FIXE_EMAIL_EST_OBLIGATOIRE',
        'ADHERENT_TEL_FIXE_MOBILE_EST_OBLIGATOIRE',
        'ADHERENT_TEL_MOBILE_EMAIL_EST_OBLIGATOIRE'
      ]
    },
    landline: {
      formKey: 'customer.phones.1',
      validatorFunction: isLandlinePhoneNumberValid,
      getValue: (phone) => phone?.number,
      baseMiddleBooleanKey: 'ADHERENT_TEL_FIXE_EST_OBLIGATOIRE',
      crossValidationMiddleBooleanKeys: [
        'ADHERENT_TEL_MOBILE_FIXE_EMAIL_EST_OBLIGATOIRE',
        'ADHERENT_TEL_FIXE_MOBILE_EST_OBLIGATOIRE',
        'ADHERENT_TEL_FIXE_EMAIL_EST_OBLIGATOIRE'
      ]
    }
  };
  const getMailMobileLandlineInputRules = useFormFieldsCrossValidation(
    form,
    getMiddleBoolean,
    fieldsMetadata
  );
  return getMailMobileLandlineInputRules;
};

export default useMailMobileLandlineCrossValidation;
